// @flow
/** @jsx jsx */

import { type Spacing, marginToCss } from '@zapier/common-utils';
import { css, jsx } from '@emotion/core';

import type { Node } from 'react';

type Props = {
  /** Children to render inside field container */
  children: Node,
  /** Label id */
  id?: string,
  /** Hide field */
  isHidden?: boolean,
  /** Wraps children in div instead of label, used for radio and checkbox groups */
  isGroup?: boolean,
  /** Field label */
  label?: string,
  margin?: Spacing,
  /** Number of grid columns to span */
  span?: number,
};

const styles = {
  container: props =>
    css(
      {
        gridColumn: props.span ? `span ${props.span}` : 'auto',
      },
      props.margin ? marginToCss(props.margin) : { marginBottom: 20 }
    ),
  label: props => ({
    fontWeight: 600,
    marginBottom: 10,
    display: !props.label ? 'none' : 'inherit',
  }),
};

const PaymentFormField = ({ children, ...props }: Props) => {
  const Container = props.isGroup ? 'div' : 'label';

  return (
    <Container
      aria-label={props.id}
      css={styles.container(props)}
      hidden={props.isHidden}
      id={props.id}
    >
      <div css={styles.label(props)}>{props.label}</div>
      {children}
    </Container>
  );
};

export default PaymentFormField;
